import { Component, OnDestroy, OnInit } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { productActivationStatus } from '../../models/products.enum'
import { SharedService } from 'src/app/shared/services/shared.service'
import { ProductsService } from '../../services/products.service'
import { ActivatedRoute, Router } from '@angular/router'
import {
	AbstractControl,
	FormControl,
	FormGroup,
	ValidatorFn,
	Validators,
} from '@angular/forms'
import {
	categoryListModel,
	brandListModel,
	productDetails,
	variantProduct,
	getProductVariant,
} from '../../models/products.model'
import { Subscription, debounceTime, filter, retry } from 'rxjs'
import { Country } from 'src/app/shared/models/general.models'
import { environment } from 'src/environments/environment'
import { MatDialog } from '@angular/material/dialog'
import { ConfirmationMessageComponent } from 'src/app/shared/components/confirmation-message/confirmation-message'
import { Editor, Toolbar, toHTML } from 'ngx-editor'
import { DomSanitizer } from '@angular/platform-browser'
import { ToastrService } from 'ngx-toastr'

@Component({
	selector: 'app-product-details',
	templateUrl: './product-details.component.html',
	styleUrls: ['./product-details.component.scss'],
})
export class ProductDetailsComponent implements OnInit, OnDestroy {
	subscription = new Subscription()
	productActivationStatus: any
	editMode: boolean = false
	addMode: boolean = true
	productForm: FormGroup = new FormGroup({})

	categoryFilter: any = {
		paging: {
			pageNumber: 1,
			pageSize: 10,
		},
		searchText: '',
	}
	showSubCategory: boolean = false
	showSubSubCategory: boolean = false
	categoryvalue: any
	subCategory: any
	subSubCategory: any
	categoryList: categoryListModel[] | null = null
	subCategoryList: categoryListModel[] | null = null
	subSubCategoryList: categoryListModel[] | null = null
	brandList: brandListModel[] | null = null
	categoryKeyWord = new FormControl('')
	subCategoryKeyWord = new FormControl('')
	subSubCategoryKeyWord = new FormControl('')
	brandKeyWord = new FormControl('')
	relatedProductsKeyWord = new FormControl('')
	selectedBrand!: any
	countries: Country[] = []
	productList: any = []
	attachmentUrl = environment.attachmentPath
	imageUrls: [] = []
	relatedProductFilter: any = {
		SearchText: '',
		Paging: {
			PageNumber: 1,
			PageSize: 50,
		},
		countryId: null,
	}
	linkedProductsDisplay!: any
	listOfIds!: any
	showLinkedProductDropDown: boolean = true
	showLinkedProductTable: boolean = false
	id!: string
	productDetails!: any
	productImagesView!: any
	viewMode: boolean = false
	selectedCountry!: any
	productNotesCount: number = 0
	descriptionAr!: Editor
	descriptionEn!: Editor
	descriptionDisplayAr!: any
	descriptionDisplayEn!: any
	mainProductDetails: any
	html!: ''
	toolbar: Toolbar = [
		['bold'],
		['italic'],
		['underline', 'strike'],
		['blockquote'],
		[{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],

		['text_color'],
		['align_left', 'align_center', 'align_right', 'align_justify'],
	]
	productHasVariances: boolean = false
	variantsArray!: variantProduct[]
	constructor(
		public translate: TranslateService,
		private SharedService: SharedService,
		private ProductsService: ProductsService,
		private route: ActivatedRoute,
		private dialog: MatDialog,
		private Router: Router,
		private toaster: ToastrService,
		private sanitizer: DomSanitizer
	) {
		this.id = this.route.snapshot.paramMap.get('id') as string

		if (this.id) {
			this.addMode = false
			this.editMode = false
			this.viewMode = true
			this.getProductDetails(this.id)
			this.initForm()
		} else {
			this.editMode = false
			this.addMode = true
			this.initForm()
		}

		this.productActivationStatus = this.SharedService.returnEnumArray(
			productActivationStatus
		)
	}

	ngOnInit(): void {
		this.descriptionAr = new Editor()
		this.descriptionEn = new Editor()
		this.getCountries()
		this.getCategoryList('')
		this.getBrandList('')
		this.subscribeToDiscount()
		this.subscription.add(
			this.categoryKeyWord.valueChanges
				.pipe(
					filter((q: any) => q?.trim().length > 1 || !q?.trim().length),
					debounceTime(700),
					retry(-1)
				)
				.subscribe(() => {
					this.getCategoryList(String(this.categoryKeyWord.value))
				})
		)
		this.subscription.add(
			this.subCategoryKeyWord.valueChanges
				.pipe(
					filter((q: any) => q?.trim().length > 1 || !q?.trim().length),
					debounceTime(700),
					retry(-1)
				)
				.subscribe(() => {
					this.getSubCategoryList(
						String(this.subCategoryKeyWord.value),
						this.getController('categoryId').value
					)
				})
		)
		this.subscription.add(
			this.subSubCategoryKeyWord.valueChanges
				.pipe(
					filter((q: any) => q?.trim().length > 1 || !q?.trim().length),
					debounceTime(700),
					retry(-1)
				)
				.subscribe(() => {
					this.getSubSubCategoryList(
						String(this.subSubCategoryKeyWord.value),
						this.getController('subCategoryId').value
					)
				})
		)
		this.subscription.add(
			this.relatedProductsKeyWord.valueChanges
				.pipe(
					filter((q: any) => q?.trim().length > 1 || !q?.trim().length),
					debounceTime(700),
					retry(-1)
				)
				.subscribe(() => {
					this.relatedProductFilter.searchText =
						this.relatedProductsKeyWord.value
					this.getRelatedProducts()
				})
		)
		this.subscription.add(
			this.brandKeyWord.valueChanges
				.pipe(
					filter((q: any) => q?.trim().length > 1 || !q?.trim().length),
					debounceTime(700),
					retry(-1)
				)
				.subscribe(() => {
					this.getBrandList(String(this.brandKeyWord.value))
				})
		)
		if (!this.viewMode) {
			this.SharedService.handleBreadCrumb('add-Product', false, {
				name: '',
				id: null,
				url: '/layout/store/products/add-product',
			})
			this.SharedService.headerTitle.next(
				`STORE.ADD_PRODUCT.ADD_PRODUCT_PAGE_TITLE`
			)
		} else {
			this.SharedService.handleBreadCrumb('view-Product', false, {
				name: '',
				id: this.id,
				url: '/layout/store/products/product-details/',
			})
			this.SharedService.headerTitle.next(
				`STORE.PRODUCT_DETAILS.PRODUCT_DETAILS`
			)
		}
	}
	subscribeToDiscount() {
		this.subscription.add(
			this.productForm.valueChanges.subscribe(() => {
				if (
					this.getController('price')?.value &&
					this.getController('discountAmount')?.value &&
					this.getController('price')?.value <=
						this.getController('discountAmount')?.value &&
					this.getController('isDiscountFixed')?.value
				) {
					this.getController('discountAmount')?.setErrors(null)

					this.getController('discountAmount')?.setErrors({
						discountMoreThanPrice: true,
					})
				} else {
					this.getController('discountAmount')?.errors?.discountMoreThanPrice
						? this.getController('discountAmount').setErrors(null)
						: null
				}

				if (!this.getController('isDiscountFixed')?.value) {
					this.getController('discountAmount')?.setErrors(null)
					this.getController('discountAmount')?.value > 100
						? this.getController('discountAmount')?.setErrors({
								percentageMax: true,
						  })
						: this.getController('discountAmount')?.setErrors(null)
				}
			})
		)
	}
	calculateLength(event: any) {
		this.productNotesCount = event.target.value.length
	}
	checkUnique(event: any) {
		if (event.target.value.length > 0) {
			this.subscription.add(
				this.ProductsService.isSkuUnique(event.target.value).subscribe(
					(res: any) => {
						res.result
							? this.productForm
									.get('skuNumber')
									?.setErrors({ unique: res.result })
							: this.productForm.get('skuNumber')?.setErrors(null)
						event.target.value.length <= 0
							? this.productForm.get('skuNumber')?.setErrors({ required: true })
							: null
					}
				)
			)
		} else {
			this.productForm.get('skuNumber')?.setErrors({ required: true })
		}
	}
	updateProductImage(event?: any) {
		this.updateProductDetails(true)
	}
	updateProductDetails(updateImg: boolean) {
		updateImg ? this.changeEditMode(updateImg) : null
		this.subscription.add(
			this.ProductsService.updateProductDetails(
				this.handleRequestBodyBeforeSave()
			).subscribe((res) => {
				res ? (this.editMode = false) : ''
				this.getProductDetails(this.id)
				this.toaster.success(
					this.translate.instant('TOASTER.PRODUCT_EDITED_SUCCESSFULLY')
				)
			})
		)
	}
	changeEditMode(updateImg: boolean) {
		this.editMode = !this.editMode
		this.addMode = false
		!updateImg ? this.initForm() : null
		this.getSubCategoryList('', this.productDetails?.category?.id)
		this.getSubSubCategoryList('', this.productDetails?.subCategory?.id)
		this.productNotesCount = this.productDetails?.productNotes?.length

		if (this.editMode && this.productDetails?.hasVariant) {
			this.hasVarianceChange(true)
		} else {
			this.getController('price')?.setValue(this.mainProductDetails?.price)
			this.getController('discountAmount')?.setValue(
				this.mainProductDetails?.discountAmount
			)
			this.getController('isDiscountFixed')?.setValue(
				this.mainProductDetails?.isDiscountFixed
			)
			this.getController('skuNumber')?.setValue(
				this.mainProductDetails?.skuNumber
			)
			this.getController('stockCount')?.setValue(
				this.mainProductDetails?.stockCount
			)
			this.getController('lowQuantity')?.setValue(
				this.mainProductDetails?.hasLowQuantity
			)
		}

		this.categoryvalue = this.productDetails?.category

		this.subCategory = this.productDetails?.subCategory

		this.subSubCategory = this.productDetails?.subSubCategory

		this.selectedBrand = this.productDetails?.brand
		this.selectedCountry = this.productDetails?.country
		this.productHasVariances = this.productDetails?.hasVariant

		this.subscribeToDiscount()

		// RELATED PRODUCT UNCOMMENT WHEN NEEDED
		// this.showLinkedProductTable = true
		// this.showLinkedProductDropDown = false
		// this.relatedProductFilter.countryId = this.productDetails?.country?.id
		// this.linkedProductsDisplay = this.productDetails.relatedProducts
		// this.getRelatedProducts(this.getController('relatedProducts').value)
		// this.getController('relatedProducts').setValue(
		// 	this.getController('relatedProducts').value.map((ele: any) => ele.id)
		// )
		// console.log(this.productForm.getRawValue())
	}
	initForm() {
		this.productForm = new FormGroup({
			name: new FormGroup({
				ar: new FormControl(
					this.productDetails?.name?.ar ? this.productDetails?.name?.ar : null,
					[Validators.required]
				),
				en: new FormControl(
					this.productDetails?.name?.en ? this.productDetails?.name?.en : null,
					[Validators.required]
				),
			}),
			description: new FormGroup({
				ar: new FormControl(
					this.productDetails?.description?.ar
						? this.productDetails?.description?.ar
						: null,
					[Validators.required, this.htmlContentRequired()]
				),
				en: new FormControl(
					this.productDetails?.description?.en
						? this.productDetails?.description?.en
						: null,
					[Validators.required, this.htmlContentRequired()]
				),
			}),
			isActive: new FormControl(
				this.productDetails?.isActive ? this.productDetails?.isActive : false
			),
			targetAudience: new FormControl(
				this.productDetails?.targetAudience?.length > 0
					? this.productDetails?.targetAudience
					: null,
				[Validators.required]
			),
			price: new FormControl(
				this.productDetails?.price ? this.productDetails?.price : null,
				[Validators.required, Validators.min(1)]
			),
			stockCount: new FormControl(
				this.productDetails?.stockCount
					? this.productDetails?.stockCount
					: null,
				[Validators.required, Validators.min(0)]
			),
			brandId: new FormControl(
				this.productDetails?.brand?.id ? this.productDetails?.brand?.id : null,
				[Validators.required]
			),
			categoryId: new FormControl(
				this.productDetails?.category?.id
					? this.productDetails?.category?.id
					: null,
				[Validators.required]
			),
			subCategoryId: new FormControl(
				this.productDetails?.subCategory
					? this.productDetails?.subCategory?.id
					: null,
				[Validators.required]
			),
			subSubcategoryId: new FormControl(
				this.productDetails?.subSubCategory
					? this.productDetails?.subSubCategory?.id
					: null,
				[Validators.required]
			),
			tenantId: new FormControl(null),
			countryId: new FormControl(
				this.productDetails?.country?.id
					? this.productDetails?.country?.id
					: null,
				[Validators.required]
			),
			gallaryImageUrls: new FormControl(
				this.productDetails?.gallaryImageUrls || [],
				[Validators.required]
			),
			relatedProducts: new FormControl(
				this.productDetails?.relatedProducts as any | []
			),
			tempRelatedProducts: new FormControl(
				this.productDetails?.relatedProducts as any | []
			),
			skuNumber: new FormControl(this.productDetails?.serialNumber || null, [
				Validators.required,
			]),
			mainImageUrl: new FormControl(this.productDetails?.mainImageUrl || '', [
				Validators.required,
			]),
			id: new FormControl(this.productDetails?.id || 0),
			productNotes: new FormControl(this.productDetails?.productNotes || ''),
			lowQuantity: new FormControl(this.productDetails?.lowQuantity || false),
			isDiscountFixed: new FormControl(
				this.productDetails?.IsDiscountFixed || true
			),
			discountAmount: new FormControl(
				this.productDetails?.discountAmount || '',
				[Validators.min(0)]
			),
			hasVariant: new FormControl(this.productDetails?.hasVariant || false),
			isNotReturnable: new FormControl(this.productDetails?.isNotReturnable || false),
		})
	}

	htmlContentRequired(): ValidatorFn {
		return (control: AbstractControl): { [key: string]: any } | null => {
			const value = control.value
			const parser = new DOMParser()
			const doc = parser.parseFromString(value, 'text/html')
			const textContent = doc.body.textContent || ''
			const isEmpty = textContent.trim().length === 0
			return isEmpty ? { required: true } : null
		}
	}
	changeProductActivationStatus(event: any) {
		this.subscription.add(
			this.ProductsService.changeProductActivationStatus(
				this.id,
				event
			).subscribe()
		)
	}
	getProductDetails(id: string) {
		this.ProductsService.getProductDetails(id).subscribe({
			next: (res: any) => {
				this.productDetails = res.result
				if (!res.result.hasVariant) {
					this.productDetails = res.result
					this.mainProductDetails = this.productDetails.productVariants[0]
				} else {
					this.productHasVariances = res.result.hasVariant

					this.productDetails.productVariants.map(
						(ele: any) => (ele.country = this.productDetails.country)
					)
				}

				this.descriptionDisplayAr = this.sanitizer.bypassSecurityTrustHtml(
					this.productDetails?.description?.ar
				)
				this.descriptionDisplayEn = this.sanitizer.bypassSecurityTrustHtml(
					this.productDetails?.description?.en
				)
			},
			error: () => {
				console.error('error')
			},
			complete: () => {
				this.initForm()
				// UNCOMMENT WHEN NEEDED RELATED PRODUCT LOGIC
				// this.getController('relatedProducts').setValue(
				// 	this.getController('relatedProducts').value.map((ele: any) => ele.id)
				// )
			},
		})
	}

	getBrandList(SearchText: String) {
		this.ProductsService.getBrandList(SearchText).subscribe(
			(res: any) => (this.brandList = res.result)
		)
	}
	getController(controlName: string) {
		return this.productForm.controls[controlName]
	}
	selectChange(event: any, data: any) {
		if (
			event?.checked &&
			!this.getController('targetAudience').value?.includes(data)
		)
			this.getController('targetAudience').setValue(
				this.getController('targetAudience')?.value
					? [...this.getController('targetAudience')?.value, data]
					: [data]
			)
		else {
			let objIndex = [...this.getController('targetAudience').value]?.indexOf(
				data
			)
			let newArray = this.getController('targetAudience').value
			newArray.splice(objIndex, 1)
			newArray?.length
				? this.getController('targetAudience').setValue(newArray)
				: this.getController('targetAudience').setValue(null)
		}
	}
	getCountries() {
		this.subscription.add(
			this.SharedService.getCountryCode().subscribe({
				next: (res: any) => {
					this.countries = res.result
				},
			})
		)
	}
	getCategoryList(keyword: string) {
		this.subscription.add(
			this.ProductsService.getCategoryList(keyword, null).subscribe(
				(res: any) => {
					this.categoryList = res.result

					this.showSubCategory = false
					this.showSubSubCategory = false
				}
			)
		)
	}
	getSubCategoryList(keyword: string, categoryId: Number) {
		this.subscription.add(
			this.ProductsService.getCategoryList(keyword, categoryId).subscribe(
				(res: any) => {
					this.subCategoryList = res?.result
					if (this.subCategoryList) {
						if (this.subCategoryList?.length > 0) {
							this.showSubCategory = true
						} else {
							this.showSubCategory = false
							this.showSubSubCategory = false
						}
					}
				}
			)
		)
	}
	getSubSubCategoryList(keyword: string, categoryId: Number) {
		this.subscription.add(
			this.ProductsService.getCategoryList(keyword, categoryId).subscribe(
				(res: any) => {
					this.subSubCategoryList = res?.result
					this.subSubCategoryList
						? this.subSubCategoryList?.length > 0
							? (this.showSubSubCategory = true)
							: (this.showSubSubCategory = false)
						: ''
				}
			)
		)
	}
	countryChange() {
		this.listOfIds = null
		this.productForm.controls['relatedProducts'].setValue([])
		this.productForm.controls['tempRelatedProducts'].setValue([])
		this.getRelatedProducts()
	}
	getRelatedProducts(listOfIds?: any) {
		listOfIds?.length > 0
			? (this.relatedProductFilter.execludedProductIds = listOfIds)
			: ''
		this.subscription.add(
			this.ProductsService.getRelatedProduct(
				this.relatedProductFilter
			).subscribe((res: any) => (this.productList = res.result.items))
		)
	}
	takeAction(type: string) {
		if (type == 'link') {
			this.linkedProductsDisplay
				? (this.linkedProductsDisplay = [
						...this.linkedProductsDisplay,
						...this.getController('tempRelatedProducts').value,
				  ])
				: (this.linkedProductsDisplay = [
						...this.getController('tempRelatedProducts').value,
				  ])

			this.productForm.controls['relatedProducts'].setValue([
				...this.getController('tempRelatedProducts').value,
				...this.getController('relatedProducts').value,
			])

			this.getController('tempRelatedProducts').reset()

			this.listOfIds = this.getController('relatedProducts').value.map(
				(ele: any) => (ele?.id ? ele.id : ele)
			)

			this.productForm.controls['relatedProducts'].setValue(this.listOfIds)
			this.getRelatedProducts(this.listOfIds)
			this.showLinkedProductDropDown = false
			this.showLinkedProductTable = true
		} else {
			this.getController('tempRelatedProducts').reset()
		}
	}
	openDialog(product: any) {
		this.dialog
			.open(ConfirmationMessageComponent, {
				width: '550px',

				data: {
					notflex: true,
					title: `${this.translate.instant(
						'STORE.ADD_PRODUCT.UNLINK_PRODUCT'
					)}`,
					titleStyle: 'text-[24px] font-DIN-Bold font-bold  text-dark-grey',
					message: `${this.translate.instant(
						'CONFIRMATION_MESSAGE.UNLINK_PRODUCT',
						{
							productName:
								this.translate.currentLang == 'en'
									? product?.name?.en
									: product?.name?.ar,
						}
					)} `,
					msgStyle:
						'ltr:font-DIN-bold font-bold rtl:font-semibold w-100 h-[30px] text-lg max-mobile:text-font-mobile-small max-mobile:inline-block my-24px',
					cancelBtn: 'ACTIONS.CANCEL',
					confirmBtn: `ACTIONS.UNLINK`,
					confirmBtnStyle: `text-off-white bg-red-error py-[15px]`,
					cancelBtnStyle: `border-[1px] border-secondry-color-Gray text-dark-grey border-solid py-[15px]`,
				},
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					res ? this.unlinkProduct(product.id) : null
				},
			})
	}

	unlinkProduct(i: any) {
		const index = this.getController('relatedProducts').value.indexOf(i)
		if (index !== -1) {
			this.getController('relatedProducts').value.splice(index, 1)
			this.productForm.controls['relatedProducts'].setValue(
				this.getController('relatedProducts').value
			)
			this.listOfIds = this.getController('relatedProducts').value
			this.linkedProductsDisplay = this.linkedProductsDisplay.filter(
				(ele: any) => ele.id !== i
			)

			this.getRelatedProducts(this.listOfIds)
			if (this.linkedProductsDisplay.length == 0) {
				this.showLinkedProductDropDown = true
				this.showLinkedProductTable = false
			}
		}
		return this.getController('relatedProducts').value
	}
	deleteImg(imgUrl: string) {
		let filterImg = this.getController('gallaryImageUrls').value.filter(
			(ele: any) => ele !== imgUrl
		)
		this.productForm.controls['gallaryImageUrls'].setValue(filterImg)
		if (this.editMode || this.viewMode) {
			let imagesObject = {
				productId: this.id,
				images: this.getController('gallaryImageUrls').value,
			}

			this.subscription.add(
				this.ProductsService.updateProductImages(imagesObject).subscribe(
					(res) => this.getProductDetails(this.id)
				)
			)
		}
	}

	updateProductGalleryImages(arrayOfImages: any) {
		let imagesObject = { productId: this.id, images: arrayOfImages }

		this.subscription.add(
			this.ProductsService.updateProductImages(imagesObject).subscribe()
		)
	}
	compareWith(a: any, b: any) {
		return a?.id == b?.id
	}
	handleRequestBodyBeforeSave() {
		let body = this.productForm.getRawValue()

		if (body?.subSubcategoryId) {
			body.categoryId = body?.subSubcategoryId
		} else if (body?.subCategoryId) {
			body.categoryId = body?.subCategoryId
		} else {
			body.categoryId = body?.categoryId
		}
		if (this.addMode) {
			body.description.en = toHTML(body?.description?.en)
			body.description.ar = toHTML(body?.description?.ar)
		}
		if (!body?.hasVariant) {
			body.productVariants = [
				{
					id: this.productDetails?.productVariants[0]?.id || 0,
					isActive: body?.isActive,
					variantName: {
						ar: '',
						en: '',
					},
					variantTypeId: null,
					price: body?.price,
					stockCount: body?.stockCount,
					isDiscountFixed: body?.isDiscountFixed,
					discountAmount: body?.discountAmount,
					hasLowQuantity: body?.lowQuantity,
					skuNumber: body?.skuNumber,
					mainImageUrl: body?.mainImageUrl,
					gallaryImageUrls: body?.gallaryImageUrls,
				},
			]

			delete body.skuNumber
			delete body.price
			delete body.lowQuantity
			delete body.isDiscountFixed
			delete body.discountAmount
			delete body.stockCount
		} else {
		}
		delete body.tempRelatedProducts
		delete body.subSubcategoryId
		delete body.subCategoryId

		return body
	}
	hasVarianceChange(event: any) {
		if (event?.checked || event == true) {
			this.productHasVariances = true

			this.productForm?.removeControl('skuNumber')
			this.productForm?.removeControl('price')
			this.productForm?.removeControl('lowQuantity')
			this.productForm?.removeControl('isDiscountFixed')
			this.productForm?.removeControl('discountAmount')
			this.productForm?.removeControl('stockCount')
			this.productForm?.addControl(
				'productVariants',
				new FormControl(null, [Validators.required])
			)
			if (this.editMode && this.productDetails?.productVariants) {
				this.getController('productVariants')?.setValue(
					this.productDetails?.productVariants
				)
			}
		} else {
			this.productForm?.addControl(
				'skuNumber',
				new FormControl('', [Validators.required])
			)
			this.productForm?.addControl(
				'price',
				new FormControl(null, [Validators.required, Validators.min(1)])
			)
			this.productForm?.addControl('lowQuantity', new FormControl(false))
			this.productForm?.addControl(
				'isDiscountFixed',
				new FormControl(true, [Validators.required])
			)
			this.productForm?.addControl(
				'discountAmount',
				new FormControl(null, [Validators.min(0)])
			)
			this.productForm?.addControl(
				'stockCount',
				new FormControl(null, [Validators.min(0), Validators.required])
			)
			this.productForm?.removeControl('productVariants')
			this.productHasVariances = false
		}
	}

	save() {
		if (this.addMode) {
			this.subscription.add(
				this.ProductsService.addProduct(
					this.handleRequestBodyBeforeSave()
				).subscribe((res) => {
					res ? this.Router.navigate(['/layout/store/products']) : ''
					this.toaster.success(
						this.translate.instant('TOASTER.PRODUCT_ADDED_SUCCESSFULLY')
					)
				})
			)
		} else {
			this.updateProductDetails(false)
		}
	}
	cancelButtonNavigation() {
		this.addMode ? this.Router.navigate(['/layout/store/products']) : ''
		this.editMode ? (this.editMode = false) : ''
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe()
		this.descriptionAr.destroy()
		this.descriptionEn.destroy()
	}
}
